import { TYPOGRAPHY_VARIANTS } from '@ui-component-library/components/Text/Text.styles';

const breakpoints = [
    {label: "None (0px and up)", value: ""},
    {label: "Mobile (576px and up)", value: "sm:"},
    {label: "Tablet (768px and up)", value: "md:"},
    {label: "Desktop (992px and up)", value: "lg:"},
    {label: "Extra Large (1200px and up)", value: "xl:"},
    {label: "Huge Large (1400px and up)", value: "2xl:"}
]

const visibilityOptions = [
    {label: "Show On Both", value: ""}, 
    {label: "Only on Mobile", value: "mob"}, 
    {label: "Only on Desktop", value: "dt"}
]

const yesNo = [
    {label: "Yes", value: "yes"}, 
    {label: "No", value: "no"},
]

const buttonOptions = [
    { label: "Core", value: "border border-spring-yellow-500 bg-spring-yellow-500 hover:bg-spring-yellow-600 hover:border-spring-yellow-600 active:bg-spring-yellow-700 active:border-spring-yellow-700" },
    { label: "Charcoal", value: "border border-charcoal-500 text-spring-yellow-500 bg-charcoal-500 hover:bg-charcoal-475 hover:border-charcoal-475 active:bg-charcoal-900 active:border-charcoal-900" },
    { label: "Spruce", value: "border border-green-spruce-500 text-white-50 bg-green-spruce-500 hover:bg-green-spruce-600 hover:border-green-spruce-600 active:bg-green-spruce-700 active:border-green-spruce-700" },
    { label: "Forest Green", value: "border border-green-forest-green-500 text-white-50 bg-green-forest-green-500 hover:bg-green-forest-green-475 hover:border-green-forest-green-475 active:bg-green-forest-green-700 active:border-green-forest-green-700" },
]

const targetOptions = [
    { label: "Default", value: "_self" },
    { label: "New tab", value: "_blank" },
    { label: "Open parent", value: "_parent" },
    { label: "Full body of window", value: "_top" }
]

const buttonStyle = [
    { label: "Regular", value: "" },
    { label: "Outline", value: "!bg-transparent !text-[#2A2E33] !border-[#2A2E33]" },
    { label: "Ghost", value: "!bg-transparent !border-transparent" },
    { label: "Outline Core", value: "!bg-transparent !text-[#2A2E33] !border-[#2A2E33]" },
]

const buttonSize = [
    { label: "Regular", value: "" },
    { label: "Small", value: "py-[11px] px-6 text-[0.8em]" },
    { label: "X-Small", value: "py-[7px] px-5 text-[0.62em]" }
]

const headerElements = [
    { label: "Heading 1 (95px)", value: "h1" },
    { label: "Heading 2 (76px)", value: "h2" },
    { label: "Heading 3 (61px)", value: "h3" },
    { label: "Heading 4 (49px)", value: "h4" },
]

const iconOptions = [
    { label: "Forest money", value: "img/icon-detail/forest-money.svg" },
    { label: "Find Buyers", value: "img/icon-detail/find-buyers.svg" },
    { label: "Safety", value: "img/icon-detail/safe-trade.svg" }
]

const colorVariables = [
    //Doberman colors
    { label: "Primary Core", value: "primary-core" },
    { label: "White", value: "white"},
    { label: "Neutral Stone", value: "neutral-stone" },
    { label: "Neutral Cloud", value: "neutral-cloud" },
    { label: "Neutral Pebble", value: "neutral-pebble" },
    { label: "Neutral Charcoal", value: "neutral-charcoal" },
    { label: "Supp Spruce", value: "supp-spruce" },
    { label: "Supp Pine", value: "supp-pine" },
    { label: "Supp Forest Green", value: "supp-forest-green" },
    { label: "Supp Plum", value: "supp-plum" },
    { label: "Supp Haze", value: "supp-haze" },
    { label: "Supp Blackberry", value: "supp-blackberry" },
    { label: "Supp Scarlet", value: "supp-scarlet" },
    { label: "Supp Redwood", value: "supp-redwood" },
    { label: "Supp Ceder", value: "supp-ceder" },
    { label: "Transparent", value: "transparent" },
]

const TextAlign = [
    { label: "Start", value: "text-left"},
    { label: "Center", value: "text-center"},
    { label: "End", value: "text-right"}
]

const TextSizes = [
    { label: "Regular", value: ""},
    { label: "Eight (10px)", value: "text-[10px] leading-[1.2] tracking-[-0.2px]"},
    { label: "Seven (13px)", value: "text-[13px] leading-[1.2] tracking-[-0.26px]"},
    { label: "Six (16px)", value: "text-[16px] leading-[1.25] tracking-[-0.32px]"},
    { label: "Five (20px)", value: "text-[20px] leading-[1.2] tracking-[-0.4px]"},
    { label: "Four (25px)", value: "text-[25px] leading-[1.12] tracking-[-0.5px]"},
    { label: "Three (31px)", value: "text-[31px] leading-[1.3] tracking-[-0.62px]"},
    { label: "Two (39px)", value: "text-[39px] leading-[1.22] tracking-[-0.78px]"},
    { label: "One (49px)", value: "text-[49px] leading-[1.15] tracking-[-0.98px]"},
    { label: "Heading Four (49px)", value: "text-[25px] leading-[1.1] tracking-[-0.75px] md:text-[49px] md:leading-[1.05] md:tracking-[-1.47px]"},
    { label: "Heading Three (61px)", value: "text-[31px] leading-[1.02] tracking-[-0.93px] md:text-[61px] md:leading-[1.04] md:tracking-[-1.83px]"},
    { label: "Heading Two (76px)", value: "text-[39px] leading-[1.01] tracking-[-1.17px] md:text-[76px] md:leading-[1] md:tracking-[-2.28px]"},
    { label: "Heading One (95px)", value: "text-[49px] leading-[1.06] tracking-[-1.47px] md:text-[95px] md:leading-[1.01] md:tracking-[-2.85px]"}
]

// Variable above should go away if we will allow breakpoints everywhere e.g. The one below is used for the breakpoints options
const textSizes = [
    { label: "Regular", value: ""},
    { label: "Eight (10px)", value: "text-[10px] leading-[1.2] tracking-[-0.2px]"},
    { label: "Seven (13px)", value: "text-[13px] leading-[1.2] tracking-[-0.26px]"},
    { label: "Six (16px)", value: "text-[16px] leading-[1.25] tracking-[-0.32px]"},
    { label: "Five (20px)", value: "text-[20px] leading-[1.2] tracking-[-0.4px]"},
    { label: "Four (25px)", value: "text-[25px] leading-[1.12] tracking-[-0.5px]"},
    { label: "Three (31px)", value: "text-[31px] leading-[1.3] tracking-[-0.62px]"},
    { label: "Two (39px)", value: "text-[39px] leading-[1.22] tracking-[-0.78px]"},
    { label: "One (49px)", value: "text-[49px] leading-[1.15] tracking-[-0.98px]"},
    { label: "Heading Four (49px)", value: "text-[25px] leading-[1.1] tracking-[-0.75px] md:text-[49px] md:leading-[1.05] md:tracking-[-1.47px]"},
    { label: "Heading Three (61px)", value: "text-[31px] leading-[1.02] tracking-[-0.93px] md:text-[61px] md:leading-[1.04] md:tracking-[-1.83px]"},
    { label: "Heading Two (76px)", value: "text-[39px] leading-[1.01] tracking-[-1.17px] md:text-[76px] md:leading-[1] md:tracking-[-2.28px]"},
    { label: "Heading One (95px)", value: "text-[49px] leading-[1.06] tracking-[-1.47px] md:text-[95px] md:leading-[1.01] md:tracking-[-2.85px]"}
]

const TextStyles = [
    { label: "Regular", value: ""},
    { label: "Forced Normal", value: "font-normal"},
    { label: "Italic", value: "italic"},
    { label: "Medium", value: "font-medium"},
    { label: "Medium Italic", value: "font-medium italic"},
    { label: "Bold", value: "font-bold"},
    { label: "Bold Italic", value: "font-bold italic"}
]

const opacityOptions = [
    { label: "50%", value: "50" },
    { label: "25%", value: "25" },
    { label: "75%", value: "75"},
    { label: "100%", value: "100"} 
]

/* no need for theme now we can use bg-${className} */
/* Do  not uncomment this for Salja virke */
const themeOptions = [
    { label: "Light", value: "bg-white" },
    { label: "Dark", value: "bg-primary-dark" },
    { label: "Secondary Light", value: "bg-secondary-light"} 
]

// New Themes
const themes = [
    { label: "Cloud", value: "neutral-cloud" },
    { label: "Charcoal", value: "neutral-charcoal" },
    { label: "White", value: "white"} 
]

const styleJustifyContent = [
    {label: "Start", value: "start"},
    {label: "End", value: "end"},
    {label: "Center", value: "center"},
    {label: "Around", value: "space-around"},
    {label: "Between", value: "space-between"},
    {label: "Evenly", value: "space-evenly"}
]

const styleAlignItems = [
    {label: "Start", value: "start"},
    {label: "End", value: "end"},
    {label: "Center", value: "stretch"},
    {label: "Around", value: "center"},
]

const contentJustify = [
    {label: "Start", value: "justify-start"},
    {label: "End", value: "justify-end"},
    {label: "Center", value: "justify-center"},
    {label: "Around", value: "justify-around"},
    {label: "Between", value: "justify-between"},
    {label: "Evenly", value: "justify-evenly"}
]

const contentAlignItems = [
    {label: "Start", value: "items-start"},
    {label: "End", value: "items-end"},
    {label: "Center", value: "items-center"},
    {label: "Baseline", value: "items-baseline"},
    {label: "Stretch", value: "items-stretch"}
]

const contentAlignSelf = [
    {label: "Start", value: "self-start"},
    {label: "End", value: "self-end"},
    {label: "Center", value: "self-center"},
    {label: "Baseline", value: "self-baseline"},
    {label: "Stretch", value: "self-stretch"}
]

// Legacy Bootstrap class values saved in Puck page JSON before the Tailwind migration.
// Render-time shim so legacy DB data keeps rendering correctly without a data migration.
// Keep in sync with the option arrays above (contentJustify / contentAlignItems / contentAlignSelf).
const LEGACY_TAILWIND_MAP = {
    'justify-content-start':   'justify-start',
    'justify-content-end':     'justify-end',
    'justify-content-center':  'justify-center',
    'justify-content-around':  'justify-around',
    'justify-content-between': 'justify-between',
    'justify-content-evenly':  'justify-evenly',
    'align-items-start':    'items-start',
    'align-items-end':      'items-end',
    'align-items-center':   'items-center',
    'align-items-baseline': 'items-baseline',
    'align-items-stretch':  'items-stretch',
    'align-self-start':    'self-start',
    'align-self-end':      'self-end',
    'align-self-center':   'self-center',
    'align-self-baseline': 'self-baseline',
    'align-self-stretch':  'self-stretch',
    'row':            'flex-row',
    'column':         'flex-col',
    'row-reverse':    'flex-row-reverse',
    'column-reverse': 'flex-col-reverse',
    'g-0': 'gap-0',
}

const toTailwindClasses = (value) => {
    if (!value) return ''
    return String(value)
        .split(/\s+/)
        .map((token) => LEGACY_TAILWIND_MAP[token] || token)
        .join(' ')
}


const filterOptions = [
    // Doberman colors
    { label: "Primary Core", value: "primary-core-filter" },
    { label: "White", value: "white-filter" },
    { label: "Neutral Stone", value: "neutral-stone-filter" },
    { label: "Neutral Cloud", value: "neutral-cloud-filter" },
    { label: "Neutral Pebble", value: "neutral-pebble-filter" },
    { label: "Neutral Charcoal", value: "neutral-charcoal-filter" },
    { label: "Supp Spruce", value: "supp-spruce-filter" },
    { label: "Supp Pine", value: "supp-pine-filter" },
    { label: "Supp Forest Green", value: "supp-forest-green-filter" },
    { label: "Supp Plum", value: "supp-plum-filter" },
    { label: "Supp Haze", value: "supp-haze-filter" },
    { label: "Supp Blackberry", value: "supp-blackberry-filter" },
    { label: "Supp Scarlet", value: "supp-scarlet-filter" },
    { label: "Supp Redwood", value: "supp-redwood-filter" },
    { label: "Supp Ceder", value: "supp-ceder-filter" },
]


const roundedOptions = [
    { label: "None", value: "rounded-0" },
    { label: "Rounded One", value: "rounded-[5px]" },
    { label: "Rounded Two", value: "rounded-[7.5px]" },
    { label: "Rounded Three", value: "rounded-[10px]" },
    { label: "Rounded Four", value: "rounded-[20px]" },
    { label: "Rounded Five", value: "rounded-[40px]" }
]

// Tailwind rounded: single config (KISS/DRY)
const roundedRadius = {
    sizes: [
        { label: "None", value: "none" },
        { label: "Small", value: "sm" },
        { label: "Default", value: "default" },
        { label: "Medium", value: "md" },
        { label: "Large", value: "lg" },
        { label: "XL", value: "xl" },
        { label: "2XL", value: "2xl" },
        { label: "3XL", value: "3xl" },
        { label: "Full", value: "full" },
    ],
    locations: [
        { label: "All", value: "all" },
        { label: "Top", value: "t" },
        { label: "Bottom", value: "b" },
        { label: "Left", value: "l" },
        { label: "Right", value: "r" },
        { label: "Top left", value: "tl" },
        { label: "Top right", value: "tr" },
        { label: "Bottom left", value: "bl" },
        { label: "Bottom right", value: "br" },
    ],
    parse(v) {
        if (!v || typeof v !== "string") return { size: "lg", location: "all" }
        const m = v.match(/^rounded(?:-(t|r|b|l|tl|tr|br|bl))?(?:-(none|sm|md|lg|xl|2xl|3xl|full))?$/)
        if (!m) return { size: "lg", location: "all" }
        return { location: m[1] || "all", size: m[2] || "default" }
    },
    build(size, location) {
        if (size === "none") return location === "all" ? "rounded-none" : `rounded-${location}-none`
        const suffix = size === "default" ? "" : `-${size}`
        return location === "all" ? (size === "default" ? "rounded" : `rounded${suffix}`) : `rounded-${location}${suffix}`
    },
    label(opts, value) {
        return opts.find((o) => o.value === value)?.label ?? value
    },
    summary(v) {
        if (!v) return "Choose radius"
        const { size, location } = this.parse(v)
        return `${this.label(this.sizes, size)}, ${this.label(this.locations, location)}`
    },
}
const getRoundedItemSummary = (value) => roundedRadius.summary(value)

const colorHex = [
        //Old new colors
        {label:"black",value:"#000000"},
        
        // Primary
        {label:"sage",value:"#A2CCB7"},
        {label:"primary-main",value :"#A2CCB7"},// rgba(162, 204, 183, 1)
        {label:"pine", value:"#1C332A"},
        {label:"primary-dark", value:"#1C332A"}, // rgba(28, 51, 42, 1)
    
        // Secondary
        {label:"secondary-light", value:"#EAEEED"}, // rgba(234, 238, 237, 1)
        {label:"secondary-main",value:"#C4D0CD"}, // rgba(196, 208, 205, 1)
        {label:"grey", value:"#8D9392"},    
        {label:"secondary-grey", value:"#8D9392"}, // rgba(141, 147, 146, 1)
        {label:"secondary-dark" ,value:"#0A0A0A"}, // rgba(10, 10, 10, 1)
        {label:"secondary-blue", value:"#00ABAC"}, // rgba(0, 171, 172, 1)
    
        // Tertiary
        {label:"tertiary-light", value:"#CAEDDC"}, // rgba(202, 237, 220, 1)
        {label: "tertiary-blue", value:"#60DFE0"}, // rgba(96, 223, 224, 1)
        {label: "tertiary-main", value:"#0C9B63"}, // rgba(12, 155, 99, 1)
        {label: "tertiary-dark", value: "#1C5740"}, // rgba(28, 87, 64, 1)
        {label: "highlight",  value: "#FF6E7E"},
        {label: "tertiary-red",  value: "#FF6E7E"}, // rgba(255, 110, 126, 1)
    
        // Alerts
        {label: "red-alert", value: "#D0342C"},
    
        // Old old colors
        {label: "blue-old", value: "#3660b9"}, // rgba(54, 96, 185, 1)
        {label: "orange-old", value: "#ec842d"}, // rgba(236, 132, 45, 1)

        // Doberman colors
        { label: "primary-core", value: "#dfff5d"},
        { label: "white", value: "#ffffff"},
        { label: "neautral-stone", value: "#d9cec1" },
        { label: "neautral-cloud", value: "#e9e9e9" },
        { label: "neutral-pebble", value: "#50514f" },
        { label: "neutral-charcoal", value: "#2a2e33" },
        { label: "supp-spruce", value: "#2faf9a" },
        { label: "supp-pine", value: "#037971" },
        { label: "supp-forest-green", value: "#023436" },
        { label: "supp-plum", value: "#6a58c6" },
        { label: "supp-haze", value: "#3c416d" },
        { label: "supp-blackberry", value: "#232347" },
        { label: "supp-scarlet", value: "#f26157" },
        { label: "supp-redwood", value: "#a84343" }, 
        { label: "supp-ceder", value: "#4c2b36" }, 
];

const boxShadow = [
    {label:"No shadow",value:"shadow-none"},
    {label:"Small Shadow",value:"shadow-sm"},
    {label:"Regular Shadow",value:"shadow"},
    {label:"Large Shadow",value:"shadow-lg"},
]

const border = [
    {label:"None", value:"border-0"},
    {label:"Border-1", value:"rounded-[5px]"}, // 5px
    {label:"Border-2", value:"rounded-[7.5px]"}, // 7.5px
    {label:"Border-3", value:"rounded-[10px]"}, // 10px
    {label:"Border-4", value:"rounded-[20px]"}, // 20px
    {label:"Border-5", value:"rounded-[40px]"}, // 40px
    {label:"Rounded Circle", value:"rounded-[50%]"}, // 50%
]

const paddingOptions = [
    { label: "1 (5px)", value: "p-[5px]" },
    { label: "2 (10px)", value: "p-[10px]" },
    { label: "3 (20px)", value: "p-[20px]" },
    { label: "4 (30px)", value: "p-[30px]" },
    { label: "5 (60px)", value: "p-[60px]" },
]

const paddingOptionsStart = [
    { label: "0 (0px)", value: "pl-[0px]" }, 
    { label: "1 (5px)", value: "pl-[5px]" },
    { label: "2 (10px)", value: "pl-[10px]" },
    { label: "3 (20px)", value: "pl-[20px]" },
    { label: "4 (30px)", value: "pl-[30px]" },
    { label: "5 (60px)", value: "pl-[60px]" }
]

const paddingOptionsEnd = [
    { label: "0 (0px)", value: "pr-[0px]" },
    { label: "1 (5px)", value: "pr-[5px]" },
    { label: "2 (10px)", value: "pr-[10px]" },
    { label: "3 (20px)", value: "pr-[20px]" },
    { label: "4 (30px)", value: "pr-[30px]" },
    { label: "5 (60px)", value: "pr-[60px]" }
]

const paddingOptionsTop = [
    { label: "0 (0px)", value: "pt-[0px]" },
    { label: "1 (5px)", value: "pt-[5px]" },
    { label: "2 (10px)", value: "pt-[10px]" },
    { label: "3 (20px)", value: "pt-[20px]" },
    { label: "4 (30px)", value: "pt-[30px]" },
    { label: "5 (60px)", value: "pt-[60px]" }
]

const paddingOptionsBottom = [
    { label: "0 (0px)", value: "pb-[0px]" },
    { label: "1 (5px)", value: "pb-[5px]" },
    { label: "2 (10px)", value: "pb-[10px]" },
    { label: "3 (20px)", value: "pb-[20px]" },
    { label: "4 (30px)", value: "pb-[30px]" },
    { label: "5 (60px)", value: "pb-[60px]" }
]

const iconSizeOptions=[
    { label: "16px", value: "16px" },
    { label: "24px", value: "24px" },
    { label: "32px", value: "32px" },
    { label: "48px", value: "48px" },
    { label: "64px", value: "64px" },
]

const colOptions = [
    {label: "One", value: 1}, 
    {label: "Two", value: 2},
    {label: "Three", value: 3},
    {label: "Four", value: 4},
]

const highlightOptions = {
    type: "object",
    objectFields: {
        words: {
            type: "array",
            arrayFields: {
                word: {
                    type: "text"
                }
            },
            getItemSummary: (t) => t.words
        },
        color: {
            type: "select",
            options: colorVariables
        },
        backgroundColor: {
            type: "select",
            options: colorVariables
        },
        rounded: {
            type: "select",
            options: roundedOptions
        },
        padding: {
            type: "select",
            options: paddingOptions
        },
    }
}

const verticalSpaceOptions=[
        { label: "8px", value: "8px" },
        { label: "16px", value: "16px" },
        { label: "24px", value: "24px" },
        { label: "32px", value: "32px" },
        { label: "40px", value: "40px" },
        { label: "48px", value: "48px" },
        { label: "56px", value: "56px" },
        { label: "64px", value: "64px" },
        { label: "72px", value: "72px" },
        { label: "80px", value: "80px" },
        { label: "88px", value: "88px" },
        { label: "96px", value: "96px" },
        { label: "104px", value: "104px" },
        { label: "112px", value: "112px" },
        { label: "120px", value: "120px" },
        { label: "128px", value: "128px" },
        { label: "136px", value: "136px" },
        { label: "144px", value: "144px" },
        { label: "152px", value: "152px" },
        { label: "160px", value: "160px" },
]

const textWidth = [
    { label: "1", value: "1"},
    { label: "2", value: "2"},
    { label: "3", value: "3"},
    { label: "4", value: "4"},
    { label: "5", value: "5"},
    { label: "6", value: "6"},
    { label: "7", value: "7"},
    { label: "8", value: "8"},
    { label: "9", value: "9"},
    { label: "10", value: "10"},
    { label: "11", value: "11"},
    { label: "12", value: "12"},
]

const spacingOptions = {
    type: "array",
    arrayFields: {
        type: 
            { 
                type: "select", 
                options: [
                    {label: "Margin", value: "m"}, 
                    {label: "Padding", value: "p"}
                ] },
        direction: 
            { 
                type: "select", 
                options: [
                    {label: "All", value: "-"}, 
                    {label: "Horizontal", value: "x-"},
                    {label: "Vertical", value: "y-"},
                    {label: "Start", value: "l-"},
                    {label: "End", value: "r-"},
                    {label: "Top", value: "t-"},
                    {label: "Bottom", value: "b-"},
                ] },
        size: 
            { 
                type: "select", 
                options: [
                    {label: "One (5px)", value: "[5px]"}, 
                    {label: "Two (10px)", value: "[10px]"},
                    {label: "Three (20px)", value: "[20px]"},
                    {label: "Four (30px)", value: "[30px]"},
                    {label: "Five (60px)", value: "[60px]"}
                ] },
        breakpoint:
            {
                type: "select",
                options: breakpoints
            }
    },
    defaultItemProps: { type: "m", direction: "-", size: "1", breakpoint: "" },
    getItemSummary: (s) => {
        if (!s.size || s.size === "") {
            return "Choose values";
        }

        const style = [s?.type, s?.direction, s?.size].filter(Boolean).join('');

        if(s.breakpoint !== "") {
            return `${s.breakpoint}!${style}`
        }
        return `!${style}`;
    }
}

const CalculateSpacing = (spacing) => {
    let elemClass = ''

    spacing.map((i) => {
        if(i?.breakpoint !== "") {
            elemClass = elemClass+(`!${i.breakpoint}${i.type}${i.direction}${i.size} `);
        } else {
            elemClass = elemClass+(`!${i.type}${i.direction}${i.size} `);
        }
    })

    return elemClass
}

const splitTextSpacingClasses = (spacingClasses) => {
    if (!spacingClasses) {
        return { contentClasses: "", wrapperPaddingClasses: "" }
    }

    const contentClasses = []
    const wrapperPaddingClasses = []
    const classNames = String(spacingClasses).trim().split(/\s+/).filter(Boolean)

    classNames.forEach((className) => {
        // Legacy generated form used in this project, e.g. "!sm-mx-[20px]".
        const legacyMatch = className.match(/^(!?)(sm-|md-|lg-|xl-|xxl-)?m([xrl])-(.+)$/)
        if (legacyMatch) {
            const [, important = "", breakpoint = "", direction = "", rest = ""] = legacyMatch
            wrapperPaddingClasses.push(`${important}${breakpoint}p${direction}-${rest}`)
            return
        }

        // Standard Tailwind variant form, e.g. "sm:!mx-3" or "!mr-[10px]".
        const variants = className.split(":")
        const base = variants.pop()
        if (!base) {
            contentClasses.push(className)
            return
        }

        const baseMatch = base.match(/^(!?)m([xrl])-(.+)$/)
        if (!baseMatch) {
            contentClasses.push(className)
            return
        }

        const [, important = "", direction = "", rest = ""] = baseMatch
        const convertedBase = `${important}p${direction}-${rest}`
        wrapperPaddingClasses.push([...variants, convertedBase].join(":"))
    })

    return {
        contentClasses: contentClasses.join(" "),
        wrapperPaddingClasses: wrapperPaddingClasses.join(" "),
    }
}

const fontSizeOptions = {
    type: "array",
    arrayFields: {
        size: 
            { 
                type: "select", 
                options: textSizes
            },
        breakpoint:
            {
                type: "select",
                options: breakpoints
            }
    },
    defaultItemProps: { size: "", breakpoint: "" },
    getItemSummary: (s) => {
        if (!s.size || s.size === "") {
            return "Choose values";
        }

        const styleArray = s.size.split(' ');
        const styling = styleArray.map((style) => {
            return s.breakpoint !== "" ? `${s.breakpoint}!${style}` : style;
        }).join(' ');
        

        return styling;
    }
}

const typographyVariantSelectOptions = [
    { label: "None", value: "" },
    ...TYPOGRAPHY_VARIANTS.map((value) => ({ label: value, value })),
]

const textVariantOptions = {
    type: "array",
    arrayFields: {
        variant: {
            type: "select",
            options: typographyVariantSelectOptions
        },
        breakpoint: {
            type: "select",
            options: breakpoints
        }
    },
    defaultItemProps: { variant: "", breakpoint: "" },
    getItemSummary: (summaryItem) => {
        if (!summaryItem.variant) return "None (use font sizes & style below)"
        const breakpoint = summaryItem.breakpoint || ""
        const bpShort = breakpoint === "" ? "base" : breakpoint.replace(/-$/, "")
        return bpShort + ": " + summaryItem.variant
    }
}

const DEFAULT_UI_TEXT_VARIANT = "text-base/leading-normal/normal"

const BREAKPOINT_TO_UI_KEY = {
    '': 'variant',
    'sm-': 'sm',
    'md-': 'md',
    'lg-': 'lg',
    'xl-': 'xl',
    'xxl-': 'twoXl',
  }

const textVariantRowsToUiProps = (rows) => {
    if (!rows || !rows.length) return null
    const uiProps = {}
    for (const row of rows){
        if(!row?.variant) continue
        const key = BREAKPOINT_TO_UI_KEY[row.breakpoint ?? ''] ?? null
        if (key){
            uiProps[key] = row.variant
        }
    }
    if (!uiProps.variant){
       const hasBreakPoint = uiProps.sm || uiProps.md || uiProps.lg || uiProps.xl || uiProps.twoXl
       if (!hasBreakPoint) return null
       uiProps.variant = DEFAULT_UI_TEXT_VARIANT
    }
    return uiProps
}

const CalculateFontSize = (sizes) => {
    if(!sizes || sizes.length === 0) {
        return ''
    };
    
    let classList = ''

    sizes.forEach((i) => {
        if(!i.size || i.size === '') return
        
        const twClassList = i.size.split(' ')
        twClassList.forEach((twClass) => {
            if(i.breakpoint !== "") {
                classList = classList+(`${i.breakpoint}!${twClass} `);
            } else {
                classList = classList+(`${twClass} `);
            }
        })
    })
    return classList
}

const highlightWordsFunc = (text, words, color, backgroundColor, rounded, padding) => {
    const regex = new RegExp(`(${words.join('|')})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) => (
        regex.test(part) ? <span key={index} className={`${color} bg-${backgroundColor} ${rounded} ${padding}`}>{part}</span> : part
    ))
}

export { 
    spacingOptions, 
    visibilityOptions,
    yesNo,
    CalculateSpacing, 
    buttonOptions,
    targetOptions,
    buttonStyle,
    buttonSize,
    headerElements, 
    iconOptions, 
    colorVariables,
    TextAlign, 
    TextSizes, 
    TextStyles, 
    opacityOptions, 
    themeOptions, 
    themes, 
    filterOptions,
    roundedOptions,
    roundedRadius,
    getRoundedItemSummary,
    highlightOptions, 
    highlightWordsFunc,
    styleJustifyContent,
    styleAlignItems,
    contentJustify,
    contentAlignItems,
    contentAlignSelf,
    toTailwindClasses,
    colorHex, 
    boxShadow, 
    border, 
    paddingOptions,
    paddingOptionsStart,
    paddingOptionsEnd,
    paddingOptionsTop,
    paddingOptionsBottom,
    iconSizeOptions,
    colOptions,
    verticalSpaceOptions,
    textWidth,
    fontSizeOptions,
    CalculateFontSize,
    textVariantOptions,
    textVariantRowsToUiProps,
    splitTextSpacingClasses
}
